/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Ask_Meeting_Feedback_BodyInputs */



/**
* | output |
* | --- |
* | "I took the minutes of this conversation. Would you like to know how it went and what could be better?" |
*
* @param {Nudge_Ask_Meeting_Feedback_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_ask_meeting_feedback_body = /** @type {((inputs?: Nudge_Ask_Meeting_Feedback_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Ask_Meeting_Feedback_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ik heb dit gesprek meegeschreven. Wil je weten hoe het liep en wat beter kan?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("J'ai pris des notes pendant cette conversation. Voulez-vous savoir comment elle s'est passée et ce qui pourrait être mieux ?")
	return /** @type {LocalizedString} */ ("I took the minutes of this conversation. Would you like to know how it went and what could be better?")
});